import React, { useMemo } from 'react';
import type { PageDetailOut } from '../types/catalog';
import { normalizePageDetail } from '../utils/normalizePageDetail';
import { TemplateRenderer } from '../templates/TemplateRenderer';

interface PageRendererProps {
  page: PageDetailOut | null;
  onComplete?: () => void;
}

/**
 * Renders a page using template_id and page_json_v1.content.sections (or normalized from blocks).
 * Normalizes so both content.sections and content.blocks work.
 */
export const PageRenderer: React.FC<PageRendererProps> = ({ page, onComplete }) => {
  const normalized = useMemo(() => normalizePageDetail(page), [page]);
  return <TemplateRenderer page={normalized} onComplete={onComplete} />;
};
